module.exports = __webpack_public_path__ + "media/brand-video.dad49b8a.mp4";